import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { WhatsAppButton } from './components/WhatsAppButton';
import { HomePage } from './pages/HomePage';
import { Caminata5KPage } from './pages/Caminata5KPage';
import { DeportesPage } from './pages/DeportesPage';
import { ExpositoresPage } from './pages/ExpositoresPage';
import { PatrocinadoresPage } from './pages/PatrocinadoresPage';
import { MuroPage } from './pages/MuroPage';
import { GraciasPage } from './pages/GraciasPage';
import { SubirDocumentoPage } from './pages/SubirDocumentoPage';
import { TerminosPage } from './pages/TerminosPage';
import { NovoeiaModal } from './components/NovoeiaModal';
import { DiverxoModal } from './components/DiverxoModal';
export function App() {
  return <div className="min-h-screen bg-white overflow-x-hidden" data-id="element-0" data-mp="28sl48zil1qg1">
      <Navbar data-id="element-1" data-mp="23w4ek0vqj40u" />
      <main data-id="element-2" data-mp="23ujmchww7x65">
        <Routes data-id="element-3" data-mp="23ut9lxqjzq85">
          <Route path="/" element={<HomePage data-id="element-5" data-mp="3ik7fqfdqo9q4" />} data-id="element-4" data-mp="23t8ea5wf0398" />
          <Route path="/caminata-canina" element={<Caminata5KPage data-id="element-7" data-mp="3ihv1odb3qjic" />} data-id="element-6" data-mp="3iiwdijzxza14" />
          {/* Redirect legacy path so old links keep working */}
          <Route path="/caminata-5k" element={<Navigate to="/caminata-canina" replace data-id="element-9" data-mp="3rbzq6q2rjiup" />} data-id="element-8" data-mp="3mjpyb4i388ps" />
          <Route path="/deportes" element={<DeportesPage data-id="element-11" data-mp="682dxcgkib2" />} data-id="element-10" data-mp="5yi8qe3h5da" />
          <Route path="/expositores" element={<ExpositoresPage data-id="element-13" data-mp="2zl3brl12165b" />} data-id="element-12" data-mp="5gbgztt38r4" />
          <Route path="/patrocinadores" element={<PatrocinadoresPage data-id="element-15" data-mp="2zmwlj96ys6hj" />} data-id="element-14" data-mp="2zlv32jnmchps" />
          <Route path="/muro" element={<MuroPage data-id="element-17" data-mp="33nq4rp9gox43" />} data-id="element-16" data-mp="33mf1rrnubte1" />
          <Route path="/gracias" element={<GraciasPage data-id="element-19" data-mp="38lro8basuyg3" />} data-id="element-18" data-mp="33mymfg4vkvvr" />
          <Route path="/subir-documento" element={<SubirDocumentoPage data-id="element-21" data-mp="38kgk2adfzoog" />} data-id="element-20" data-mp="38li8dgjgy7o4" />
          <Route path="/terminos" element={<TerminosPage data-id="element-23" data-mp="3dlw5w4ng1z7w" />} data-id="element-22" data-mp="3dkl3o99ncziw" />
        </Routes>
      </main>
      <Footer data-id="element-24" data-mp="nvj53kddcmru" />
      <WhatsAppButton data-id="element-25" data-mp="nvssd0714ftu" />
      <NovoeiaModal data-id="element-26" data-mp="nuhhkgf627t8" />
      <DiverxoModal data-id="element-27" data-mp="nv0x5qhcgk43" />
    </div>;
}